module.exports = __webpack_public_path__ + "img/logoClub.14fe9319.png";